import MotifAjustementStockFormController from './motif.ajustement.stock.form.controller';

export default {
    template: require('./motif.ajustement.stock.form.html'),
    controller: MotifAjustementStockFormController
};
